// extracted by mini-css-extract-plugin
module.exports = {"skills":"skills_skills__3_Kx3","frontend":"skills_frontend__1qydD","backend":"skills_backend__1r54N","skill":"skills_skill__M-VBb"};